import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { GradoService } from '../../../../services/grado.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Subscription, Subject } from 'rxjs';
import { take, filter, takeUntil } from 'rxjs/operators';
import { Grado } from 'src/app/models/grado.model';
import { ResultList } from '../../../../interfaces/generic.interface';
import { MatDialog } from '@angular/material/dialog';
import { GradoalumnopasajeComponent } from '../acciones/gradoalumnopasaje.component';
import * as fs from 'file-saver';
import { CuentaCorrienteService } from 'src/app/services/cuentacorriente.service';
import { Workbook } from 'exceljs';

@Component({
  selector: 'app-grados-list',
  templateUrl: './grados-list.component.html',
  styleUrls: ['grados-list.component.scss'],
})
export class GradosListComponent implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns = ['nombre', 'descripcion', 'categoria', 'id'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  length = 0;
  pageIndex = 0;
  subscriptions: Subscription[] = [];
  filtro = '';
  fuenteTitulo = 'Verdana,sans-serif';
  tipoFormatoExcel =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  fuenteRow = 'Comic Sans MS';
  private regex = /[\\/\\?*:\\[\\]]/g;
  private destroy$ = new Subject<void>();
  private searchSubscription?: Subscription;

  constructor(
    private dialog: MatDialog,
    private gradoService: GradoService,
    private cuentaCorrienteService: CuentaCorrienteService
  ) {}

  ngOnInit() {
    this.gradoService
      .getGradosPorEscuela(this.pageIndex, 10, '')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((fs: ResultList<Grado>) => {
        this.dataSource.data = fs.resultList;
        this.length = fs.total;
        if (this.paginator) {
          this.paginator.length = this.length;
        }
      });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.getData(0, 10, filterValue);
  }

  getData(pageIndex: number, pageSize: number, filter: string) {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    this.searchSubscription = this.gradoService
      .getGradosPorEscuela(pageIndex, pageSize, filter)
      .pipe(takeUntil(this.destroy$))
      .subscribe((fs: ResultList<Grado>) => {
        this.dataSource.data = fs.resultList;
        this.length = fs.total;
        if (this.paginator) {
          this.paginator.length = this.length;
        }
      });
  }
  public getServerData(event?: PageEvent) {
    if (event) {
      this.getData(event.pageIndex + 1, event.pageSize, '');
    }
    return event;
  }
  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }

  pasarSiguiente(grado: Grado) {
    const dialogRef = this.dialog.open(GradoalumnopasajeComponent, {
      height: '400px',
      width: '500px',
      data: { grado },
    });
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  aranceles() {
    this.getIngresoEgresosYFiltro(null);
  }

  valorArancel(d){
    return Number(d.pagado) == 0 ? '--' : Number(d.total) == Number(d.pagado) ? 'PT' : d.pagado;
  }

  getIngresoEgresosYFiltro(grado: Grado) {
    let anio = new Date().getFullYear();
    if (!!this.filtro && !isNaN(parseInt(this.filtro))) {
      anio = parseInt(this.filtro);
    }
    let gradoId = grado != null ? grado.id : 0;
    

    this.subscriptions.push(
      this.cuentaCorrienteService
        .getCCPorAnio(anio, gradoId)
        .pipe(take(1))
        .subscribe((result) => {
          let resultData = result.resultList;
          if (result.resultList.length > 0) {
            let columns = [
              'Alumno/a',
              'Febrero',
              'Marzo',
              'Abril',
              'Mayo',
              'Junio',
              'Julio',
              'Agosto',
              'Septiembre',
              'Octubre',
              'Noviembre',
              'Diciembre',
              'Matricula',
            ];
            
          
            let data = Array<string>();
            /**grupo por grado */
            let groupByGradoAlumno = this.groupBy(
              resultData,
              (pet) => pet.alumno.grado.id
            );

            const workbook = new Workbook();
            groupByGradoAlumno.forEach((g: any) => {
            let gradoNombre = g[0].alumno.grado.nombre;
            let sheetNombre = `${gradoNombre.slice(0, 25)} - ${g[0].alumno.grado.id}`;
            gradoNombre = gradoNombre.replace(this.regex, '');
            let indexWS = workbook.worksheets.findIndex(ws => ws.name === sheetNombre);
            
            if(indexWS != -1){
              sheetNombre = sheetNombre + indexWS;
            }
            const worksheet = workbook.addWorksheet(sheetNombre, {
              views: [{ state: 'frozen', ySplit: 1 }],
            });
            const titleRow = worksheet.addRow(columns);
            worksheet.addRow([
              `[Año: ${anio}] - [Grado: ${gradoNombre}]`,
            ]);
            
            worksheet.addRow([]);
            titleRow.font = {
              name: this.fuenteTitulo,
              family: 4,
              bold: true,
              size: 10,
            };
              /**grupo por alumno */
              let groupByAlumno = this.groupBy(
                g,
                (pet) => pet.alumno.id
              );
              groupByAlumno.forEach((a: any) => {
                //let al = result.resultList.filter(x => x.alumno.id == f.alumno.id);
                let Matricula = '--',
                  Feb = '--',
                  Mar = '--',
                  Abr = '--',
                  May = '--',
                  Jun = '--',
                  Jul = '--',
                  Ago = '--',
                  Sep = '--',
                  Oct = '--',
                  Nov = '--',
                  Dic = '--';
                //ver aca si hacer un grup by antes y luego iterear por el grup
                data = [];
                a.forEach((d) => {
                  if (d.mes == 1) {
                    Matricula = this.valorArancel(d);
                  } else if (d.mes == 2) {
                    Feb = this.valorArancel(d);
                  } else if (d.mes == 3) {
                    Mar = this.valorArancel(d);
                  } else if (d.mes == 4) {
                    Abr = this.valorArancel(d);
                  } else if (d.mes == 5) {
                    May = this.valorArancel(d);
                  } else if (d.mes == 6) {
                    Jun = this.valorArancel(d);
                  } else if (d.mes == 7) {
                    Jul = this.valorArancel(d);
                  } else if (d.mes == 8) {
                    Ago = this.valorArancel(d);
                  } else if (d.mes == 9) {
                    Sep = this.valorArancel(d);
                  } else if (d.mes == 10) {
                    Oct = this.valorArancel(d);
                  } else if (d.mes == 11) {
                    Nov = this.valorArancel(d);
                  } else if (d.mes == 12) {
                    Dic = this.valorArancel(d);
                  }
                });
                data.push(a[0].alumno.apellido + ' ' + a[0].alumno.nombre);
                data.push(Feb.toString());
                data.push(Mar.toString());
                data.push(Abr.toString());
                data.push(May.toString());
                data.push(Jun.toString());
                data.push(Jul.toString());
                data.push(Ago.toString());
                data.push(Sep.toString());
                data.push(Oct.toString());
                data.push(Nov.toString());
                data.push(Dic.toString());
                data.push(Matricula.toString());

                worksheet.addRow(data);
              });
            });

            this.escribirArchivoExcel(
              workbook,
              `Aranceles-${anio}-${grado?.nombre ?? 'todos'}.xlsx`
            );
          }
        })
    );
  }
  escribirArchivoExcel(workbook: Workbook, nombreArchivo) {
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: this.tipoFormatoExcel });
      fs.saveAs(blob, nombreArchivo);
    });
  }
}
